import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { AmplitudeUserProperties } from "@lifeat/shared/amplitude/AmplitudeUserProperties";
import { UserType, UserTypeField, UserTypeKey, UserTypeLabel } from "@lifeat/shared/user/UserType";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import { GA4UserProperties } from "@analytics/GoogleAnalytics/GA4Service";
import * as GA4Service from "@analytics/GoogleAnalytics/GA4Service";
import LifeAtSelectInput from "@common/LifeAtSelectInput/LifeAtSelectInput";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import * as UserSettingsService from "../../../service/UserSettingsService";

const DataFieldsWrapper = styled.div<{ highlightField: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    color: ${(props) => (props.highlightField ? props.theme.textColorSpecial : props.theme.textColorPrimary)};
`;

const Label = styled.span`
    padding: 2px;
`;

const USER_TYPE_PROMPT_LABEL = "Work Type:";
const USER_TYPE_SELECTOR_PLACEHOLDER = "How would you best describe yourself?";
const USER_TYPE_SELECTOR_TOOLTIP = "This will help us create the best experience for you";

interface UserDataFieldsProps {
    flagDataUpdated: () => void;
    clearErrors: () => void;
    closeModalOnChange: () => void;
}
export default function UserDataFields(props: UserDataFieldsProps) {
    const amplitudeService = AmplitudeService.getInstance();

    const { user, userData }: UserContextType = useUserContext();

    const [userType, setUserType] = useState<UserType>(undefined);

    useEffect(() => {
        if (userData?.userType !== undefined && userType === undefined) {
            setUserType(userData.userType);
        }
    }, [userData?.userType]);

    const handleUserTypeSelect = (userTypeKey?: string) => {
        if (user && userData && userTypeKey) {
            const newUserType: UserType = UserTypeField[userTypeKey];
            setUserType(newUserType);
            props.clearErrors();

            if (newUserType !== userData.userType) {
                UserSettingsService.updateUserTypeValue(user.uid, newUserType);
                if (userData.userType === undefined) {
                    props.closeModalOnChange();
                }
                props.flagDataUpdated();

                // Apply the user property to our analytics tracking.
                amplitudeService.setUserProp(AmplitudeUserProperties.USER_TYPE, newUserType);
                GA4Service.setUserProperty(GA4UserProperties.user_type, newUserType);
            }
        }
    };

    const userTypeOptions = Object.entries(UserTypeLabel).map(([userTypeKey, userTypeVal]) => ({
        label: userTypeVal,
        value: userTypeKey,
    }));

    return (
        <DataFieldsWrapper highlightField={!userType} className={"user-data-fields-wrapper"}>
            <Label>{USER_TYPE_PROMPT_LABEL}</Label>
            <LifeAtSelectInput
                options={userTypeOptions}
                value={UserTypeKey[userType]}
                placeholder={USER_TYPE_SELECTOR_PLACEHOLDER}
                onChange={handleUserTypeSelect}
                tooltip={USER_TYPE_SELECTOR_TOOLTIP}
            />
        </DataFieldsWrapper>
    );
}
